import React from "react";
import { Box, Typography } from "@mui/material";
import { BondNumberSelect } from "../Helpers/BondNumberSelect";
import { HISTORIC_DATA_UPDATE_ERRORS } from "./historicCreationSharedPropTypes";

const ProbateHistoricBondNumberSection = ({ data, updateData, errors }) => (
  <Box
    className="bg-gray-100 p-6 rounded-lg shadow-md max-w-3xl mx-auto mt-8"
    sx={{ border: "1px solid #e0e0e0" }}
  >
    <Typography variant="h5" className="font-bold mb-4">
      Bond Number
    </Typography>
    <BondNumberSelect data={data} updateData={updateData} />
    {errors.bond_number && (
      <Typography color="error" variant="body2">
        {errors.bond_number}
      </Typography>
    )}
  </Box>
);

ProbateHistoricBondNumberSection.propTypes = HISTORIC_DATA_UPDATE_ERRORS;

export default ProbateHistoricBondNumberSection;
